// removed by extract-text-webpack-plugin
module.exports = {"base":"LoadingScreen_base--1ZFtF","base__gamefield":"LoadingScreen_base__gamefield--3IUAI","baseGamefield":"LoadingScreen_base__gamefield--3IUAI","base__window":"LoadingScreen_base__window--2JvFD","baseWindow":"LoadingScreen_base__window--2JvFD","base__fullscreen":"LoadingScreen_base__fullscreen--2l0us","baseFullscreen":"LoadingScreen_base__fullscreen--2l0us"};


//////////////////
// WEBPACK FOOTER
// ./components/LoadingScreen/LoadingScreen.scss
// module id = 2086
// module chunks = 16